import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useFetchQueries } from '@/shared/api';
import { endpoints } from '@/shared/const/endpoints.const';
import { PROFILE_LOCALSTORAGE_KEY } from '@/shared/const/localstorage.const';
import storage from '@/shared/lib/storage';
import { useBoundStore } from '@/shared/store';
import { GetRequestResponse } from '@/shared/types/requests.types';
import { UserData } from '@/shared/types/user.types';

export function useProfileFetching(isEnabled = true) {
  const { setProfile, setPermissions } = useBoundStore(
    useShallow((state) => ({
      setProfile: state.setProfile,
      setPermissions: state.setPermissions,
    })),
  );

  const {
    data: profileData,
    refetch: refetchProfile,
    isFetching: isProfileFetching,
  } = useFetchQueries<GetRequestResponse<UserData>>({
    url: endpoints.PROFILE,
    refetchOnWindowFocus: false,
    enabled: isEnabled,
  });

  useEffect(() => {
    if (profileData) {
      //save profile data in store and LS
      setProfile(profileData.data);
      storage.set(PROFILE_LOCALSTORAGE_KEY, JSON.stringify(profileData?.data));
      setPermissions(profileData?.data?.role?.permissions ?? []);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileData]);

  return {
    refetchProfile,
    isProfileFetching,
  };
}
